module.exports = __webpack_public_path__ + "static/media/au-ts.6bb261b3.svg";